import { render, staticRenderFns } from "./007ceremonyVideo.vue?vue&type=template&id=712470a1&"
import script from "./007ceremonyVideo.vue?vue&type=script&lang=js&"
export * from "./007ceremonyVideo.vue?vue&type=script&lang=js&"
import style0 from "./007ceremonyVideo.vue?vue&type=style&index=0&id=712470a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports